<template>
    <v-dialog v-model="$store.state.loginDialogStatus" scrollable persistent :overlay="false" max-width="400px"
        transition="dialog-transition">
        <v-card class="main-bg-color">
            <v-card-actions>
                <h3>{{ $t('login_modal.title') }}</h3>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="$store.commit('setLoginDialogStatus', false)">
                    {{ $t('login_modal.close_btn') }}
                </v-btn>
            </v-card-actions>

            <template v-if="loginStep == 1">
                <v-card-text>
                    <v-text-field dir="ltr" type="number" hide-details
                        :placeholder="$t('login_modal.step1.mobile_placeholder')"
                        :label="$t('login_modal.step1.mobile_label')" append-inner-icon="mdi-cellphone" v-model="mobile"
                        variant="outlined"></v-text-field>
                    <p class="text-caption mt-3">
                        <v-icon>mdi-checkbox-marked-outline</v-icon>
                        {{ $t('login_modal.step1.terms_text') }}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn block class="mb-3" variant="outlined" color="primary" rounded :loading="loading"
                        @click="Login">
                        {{ $t('login_modal.step1.submit_btn') }}
                    </v-btn>
                </v-card-actions>
            </template>

            <template v-if="loginStep == 2">
                <v-card-text>
                    <v-text-field dir="ltr" type="number" hide-details
                        :placeholder="$t('login_modal.step2.code_placeholder')"
                        :label="$t('login_modal.step2.code_label')" append-inner-icon="mdi-numeric"
                        v-model="verification" variant="outlined"></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mb-3" variant="outlined" color="red" rounded
                        @click="loginStep = 1; verification = '';">
                        {{ $t('login_modal.step2.edit_btn') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-3" variant="outlined" rounded color="primary" :loading="loading" @click="Verify">
                        {{ $t('login_modal.step2.verify_btn') }}
                    </v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "LoginModal",
        data: () => ({
            loading: false,
            loginStep: 1,
            mobile: "",
            verification: "",
            hashToken: "",
            otpAbortController: null, // برای لغو در صورت بسته شدن دیالوگ
        }),
        watch: {
            // وقتی کاربر وارد مرحله ۲ می‌شود، شروع به گوش دادن به OTP می‌کنیم
            loginStep(newVal) {
                if (newVal === 2) {
                    this.startOtpListener();
                } else {
                    this.stopOtpListener();
                }
            },
        },
        methods: {
            async Login() {
                this.loading = true;
                try {
                    const response = await this.$api.post('/booking/login', {
                        mobile: this.mobile,
                        id: this.$store.state.info.form_id
                    });
                    if (response.data.success) {
                        this.hashToken = response.data.data;
                        this.loginStep = 2;
                    }
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            },
            async Verify() {
                this.loading = true;
                try {
                    const response = await this.$api.post('/booking/verify', {
                        mobile: this.mobile,
                        verification: this.verification,
                        hashToken: this.hashToken,
                        id: this.$store.state.info.form_id
                    });
                    if (response.data.success) {
                        this.$store.commit('setAuthToken', response.data.token);
                        if (!!response.data.data.mobile && response.data.data.mobile.length > 2) {
                            this.$store.dispatch('setMobileAndConnectSocket', response.data.data.mobile);
                        }
                        if (!!response.data.data.addresses && response.data.data.addresses.length > 0) {
                            this.$store.commit('setAddresses', response.data.data.addresses);
                        }
                        this.$store.commit('setLoginDialogStatus', false);
                    }
                } catch (error) {
                    console.error(error);
                }
                this.loading = false;
            },
            async startOtpListener() {
                if (!("OTPCredential" in window)) {
                    console.log("❌ WebOTP API not supported on this device.");
                    return;
                }

                try {
                    this.otpAbortController = new AbortController();
                    const content = await navigator.credentials.get({
                        otp: {
                            transport: ["sms"]
                        },
                        signal: this.otpAbortController.signal,
                    });
                    if (content && content.code) {
                        console.log("✅ OTP received:", content.code);
                        this.verification = content.code; // پر کردن input
                        // به‌صورت خودکار تأیید هم انجام بده:
                        this.Verify();
                    }
                } catch (err) {
                    console.warn("OTP listening stopped:", err);
                }
            },

            stopOtpListener() {
                if (this.otpAbortController) {
                    this.otpAbortController.abort();
                    this.otpAbortController = null;
                }
            },
        },
        beforeUnmount() {
            this.stopOtpListener();
        },
    };
</script>

<style>
    /* hide number arrow */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>